<script>
import { Swiper, Pagination } from 'swiper'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'

export default {
  name: 'MySwiperComponent',
  emit: ['update-index'],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      new Swiper('.swiper-container', {
        slidesPerView: 1.2,
        spaceBetween: 8,
        loop: false,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        modules: [Pagination],
        on: {
          slideChange: (el) => {
            this.$emit('update-index', el.realIndex)
          },
        }
      })
    },
  },
}
</script>
<template>
  <div v-if="data.length > 1" class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(info, index) in data" :key="info.id">
        <div class="content">
          <img class="dog_card" src="@/assets/images/dog_card.png" />
          <div class="info_time">
            <div>累積期限：{{ $dayjs(info.e_date, 'YYYYMMDD').format('YYYY/MM/DD') }}</div>
            <div>兌換期限：{{ $dayjs(info.ex_date, 'YYYYMMDD').format('YYYY/MM/DD') }}</div>
          </div>
          <div class="info_container">
            <div class="info_content">
              <div class="">消費金額</div>
              <div class="info_point force-font-14">
                <img width="24" height="24" v-if="index === 0" src="@/assets/images/money_o.svg" />
                <img width="24" height="24" v-else src="@/assets/images/money_s.svg" />
                {{ info.amount }}
              </div>
            </div>
            <div class="info_content">
              <div class="">累積點數</div>
              <div class="info_point force-font-14">
                <img width="24" height="24" v-if="index === 0" src="@/assets/images/foot_o.svg" />
                <img width="24" height="24" v-else src="@/assets/images/foot_s.svg" />
                {{ info.ac_point }}
                <label class="">點</label>
              </div>
            </div>
            <div class="info_content">
              <div class="">剩餘點數</div>
              <div class="info_point force-font-14">
                <img width="24" height="24" v-if="index === 0" src="@/assets/images/foot_o.svg" />
                <img width="24" height="24" v-else src="@/assets/images/foot_s.svg" />
                {{ info.rm_point }}<label class="">點</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
  <div class="static-slide" v-else-if="data.length === 1">
    <div class="content2 siliver">
      <div class="bslide" v-for="info in data" :key="info.id">
        <div class="contentone" :class="[info.e_date > $dayjs().format('YYYYMMDD') ? '' : 'siliver']">
          <img class="dog_card" src="@/assets/images/dog_card.png" />
          <div class="info_time">
            <div>累積期限：{{ $dayjs(info.e_date, 'YYYYMMDD').format('YYYY/MM/DD') }}</div>
            <div>兌換期限：{{ $dayjs(info.ex_date, 'YYYYMMDD').format('YYYY/MM/DD') }}</div>
          </div>
          <div class="info_container">
            <div class="info_content">
              <div class="">消費金額</div>
              <div class="info_point force-font-14">
                <img width="24" height="24" v-if="info.e_date > $dayjs().format('YYYYMMDD')" src="@/assets/images/money_o.svg" />
                <img width="24" height="24" v-else src="@/assets/images/money_s.svg" />
                {{ info.amount }}
              </div>
            </div>
            <div class="info_content">
              <div class="">累積點數</div>
              <div class="info_point force-font-14">
                <img width="24" height="24" v-if="info.e_date > $dayjs().format('YYYYMMDD')" src="@/assets/images/foot_o.svg" />
                <img width="24" height="24" v-else src="@/assets/images/foot_s.svg" />
                {{ info.ac_point }}
                <label class="">點</label>
              </div>
            </div>
            <div class="info_content">
              <div class="">剩餘點數</div>
              <div class="info_point force-font-14">
                <img width="24" height="24" v-if="info.e_date > $dayjs().format('YYYYMMDD')" src="@/assets/images/foot_o.svg" />
                <img width="24" height="24" v-else src="@/assets/images/foot_s.svg" />
                {{ info.rm_point }}<label class="">點</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="static-slide" v-else>
    <div class="content2">
      <div class="bslide" v-for="info in 1" :key="info.id">
        <div class="contentone">
          <img class="dog_card" src="@/assets/images/dog_card.png" />
          <div class="info_time">
            <div>累積期限：</div>
            <div>兌換期限：</div>
          </div>
          <div class="info_container">
            <div class="info_content">
              <div class="">消費金額</div>
              <div class="info_point force-font-14">
                <img style="width: 28px; height: 28px" src="@/assets/images/money_o.svg" />
                0
              </div>
            </div>
            <div class="info_content">
              <div class="">累積點數</div>
              <div class="info_point force-font-14">
                <img width="24" height="24" src="@/assets/images/foot_o.svg" />
                0
                <label class="">點</label>
              </div>
            </div>
            <div class="info_content">
              <div class="">剩餘點數</div>
              <div class="info_point force-font-14">
                <img width="24" height="24" src="@/assets/images/foot_o.svg" />
                0<label class="">點</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.swiper-container {
  width: 100%;
  padding: 24px 0px;
  overflow-x: hidden;
  position: relative; /* 分頁指示器需要相對定位 */
}

.swiper-slide {
  width: auto; /* 自動由 Swiper 控制寬度 */
  text-align: center;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: -1px 2px 10px -2px #4b251814, 1px 1px 4px -2px #4b25181f;
}

.bslide {
  width: 100%; /* 自動由 Swiper 控制寬度 */
  aspect-ratio: 312/174;
  text-align: center;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: -1px 2px 10px -2px #4b251814, 1px 1px 4px -2px #4b25181f;
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 17px 18.5px 24px 20px;
  text-align: start;
  gap: 26px;
}

.content2 {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 12px 31.5px 24px;
  text-align: start;
  width: 100%;
  gap: 26px;
}

.contentone {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 17px 18.5px 24px 20px;
  text-align: start;
  width: 100%;
  height: 100%;
  /* gap: 26px; */
}

.bslide .contentone {
  background: linear-gradient(225.89deg, #f9d5c3 -2.61%, #ff9f4b 97.28%);
}

.bslide:nth-child(2) .contentone {
  background: linear-gradient(225.89deg, #f2f2f2 -2.61%, #909090 97.28%);
}

.bslide .contentone.siliver {
  background: linear-gradient(225.89deg, #f2f2f2 -2.61%, #909090 97.28%);
}

.swiper-slide .content {
  background: linear-gradient(225.89deg, #f9d5c3 -2.61%, #ff9f4b 97.28%);
}

.swiper-slide:nth-child(2) .content {
  background: linear-gradient(225.89deg, #f2f2f2 -2.61%, #909090 97.28%);
}
.info_time {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-weight: bold;
  font-size: 12px;
  /* line-height: 12.4px; */
  letter-spacing: 4%;
  color: white;
}
.info_container {
  position: relative;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 14px;
  padding: 12px 21px;
}
.dog_card {
  position: absolute;
  bottom: 0;
  right: 0;
}
.info_content {
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 12px;
  font-weight: normal;
  line-height: 16.8px;
  letter-spacing: 4%;
  font-size: 14px;
  color: #0D0C0C;
}
.info_point {
  display: flex;
  align-items: center;
  gap: 3.5px;
}
.info_point img {
  width: 28px;
  height: 28px;
}
:deep(.swiper-pagination) {
  position: absolute;
  bottom: 4px;
  left: 0;
  right: 0;
  text-align: center;
}

:deep(.swiper-pagination-bullet) {
  background-color: #909090;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  transition: 0.3s;
  /* margin: 0px 6px !important; */
}

:deep(.swiper-pagination-bullet-active) {
  width: 12px;
  border-radius: 10px;
  background-color: #ff7649;
}
</style>
